import IntranetLayout from "@/components/IntranetLayout";
import ModuleHeader from "@/components/voff/ModuleHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Heart, AlertTriangle } from "lucide-react";

const PULSE = [
  { vessel: "Velocity Vanguard", score: 8.4, trend: "↑", responses: 11, flags: 0 },
  { vessel: "Velocity Cobalto", score: 7.6, trend: "→", responses: 9, flags: 1 },
  { vessel: "Velocity Paladio", score: 8.9, trend: "↑", responses: 10, flags: 0 },
  { vessel: "Velocity Lerwick", score: 6.8, trend: "↓", responses: 8, flags: 2 },
];
const THEMES = [
  { theme: "Food quality (galley)", sentiment: "Positive", mentions: 14 },
  { theme: "Connectivity (Starlink)", sentiment: "Positive", mentions: 22 },
  { theme: "Rotation length (28-day)", sentiment: "Mixed", mentions: 9 },
  { theme: "Cabin temperature (HVAC)", sentiment: "Negative", mentions: 6 },
  { theme: "Shore leave at port calls", sentiment: "Negative", mentions: 4 },
];

const CrewWelfare = () => (
  <IntranetLayout>
    <ModuleHeader title="Crew Welfare Pulse" subtitle="Anonymous Welfare Monitoring & Intervention Engine"
      stats={[{ label: "Fleet score", value: "7.9", tone: "good" }, { label: "Open flags", value: 3, tone: "alert" }]} />
    <div className="grid lg:grid-cols-3 gap-6">
      <Card className="lg:col-span-2 border-[#D0DDE6]"><CardContent className="p-5">
        <h3 className="font-bold text-[#00283C] mb-3">Welfare Score by Vessel</h3>
        {PULSE.map(p => (
          <div key={p.vessel} className="border-b border-[#D0DDE6]/50 py-3">
            <div className="flex justify-between items-center mb-1">
              <div className="font-bold text-sm text-[#00283C]">{p.vessel}</div>
              <div className="flex items-center gap-3 text-sm"><span className="text-2xl font-bold text-[#288CC8]">{p.score}</span><span>{p.trend}</span>{p.flags > 0 && <Badge className="bg-[#E8A020] text-white">{p.flags} flag{p.flags>1?"s":""}</Badge>}</div>
            </div>
            <Progress value={p.score * 10} className="h-1.5" />
            <div className="text-xs text-[#6B8A9A] mt-1">{p.responses}/12 responses this period</div>
          </div>
        ))}
      </CardContent></Card>
      <Card className="border-[#D0DDE6]"><CardContent className="p-5">
        <h3 className="font-bold text-[#00283C] mb-3">Sentiment Themes</h3>
        {THEMES.map(t => (
          <div key={t.theme} className="border-b border-[#D0DDE6]/50 py-2">
            <div className="text-sm font-medium text-[#00283C]">{t.theme}</div>
            <div className="flex justify-between text-xs mt-0.5"><Badge variant="outline" className={t.sentiment === "Negative" ? "border-[#C83228] text-[#C83228]" : t.sentiment === "Positive" ? "border-[#2CA048] text-[#2CA048]" : "border-[#E8A020] text-[#E8A020]"}>{t.sentiment}</Badge><span className="text-[#6B8A9A]">{t.mentions} mentions</span></div>
          </div>
        ))}
      </CardContent></Card>
    </div>
  </IntranetLayout>
);
export default CrewWelfare;
